import { render, staticRenderFns } from "./weather-status-bar.vue?vue&type=template&id=ba22dc72&scoped=true"
import script from "./weather-status-bar.vue?vue&type=script&lang=js"
export * from "./weather-status-bar.vue?vue&type=script&lang=js"
import style0 from "./weather-status-bar.vue?vue&type=style&index=0&id=ba22dc72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba22dc72",
  null
  
)

export default component.exports